import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


function DocumentationVideoDisplayPageContent() {

	return (
		<Box sx={{ width: '100%', maxWidth: 1024 }}>
			<Typography variant="h5" gutterBottom>
				Video Displays full flow description
			</Typography>
			<Typography variant="body1" gutterBottom>
				Elements included in product price are
				<ol>
					<li>Images (slides) in video display</li>
					<li>Participation certificate</li>
					<li>Print brochure</li>
					<li>Personal flyer</li>
				</ol>
				Artists will also receive documentation photos from their image in the display.
			</Typography>
			<Typography variant="body1" gutterBottom>
				<ul>
					<li>Artists receive invite via email for open call, prompted to go to website page to see details and participate.</li>
					<li>Artist not interested: replies to our email to let us know, gmail tag "not interested" to zapier "not interested tag" in KIT</li>
					<li>Artist fills out participation form, raw data from form goes to sheet, images go to dropbox. Raw data entries sheet columns are (..) - Image file name structure is (..)</li>
					<li>Zapier runs, marking email as "participant", so excluded from further invites.</li>
					<li>Call ends, production time.</li>
				</ul>
				Artists will also receive documentation photos from their image in the display.
			</Typography>
			<Typography variant="body1" gutterBottom>
				Prep and production of elements
				<ul>
					<li><b>Video Slides</b> each slide includes Artist Name, Country, Image1=Artwork1, Image1 Caption, QR Code Image</li>
					<li><b>Print Brochure</b> use datamerge. Sheet <b>Brochure_DMerge</b> needs LastName for order, (delete Lastname col before uploading) Artist Name, Country, ImageFileName (just 1, sort with formula or remove duplicate rows by artistname col).</li>
					<li><b>Participation Certificates</b> create in inDesign, export and upload.</li>
					<li><b>Personal Flyer</b> dynamic elements 2: artist name and image1 prep. 1. Sheet with Artist Names, export csv. - Produce in flyer maker: upload names.csv - upload images.</li>
					<li><b>Proofing</b> Artists must receive their (only) slides to confirm accuracy of info. Reply back with corrections or approve. Corrections must be applied in sheet and in slides.</li>
				</ul>
				<b>problematic: </b> names need to match images. folder with images includes all artists images so some have more than one. so the names.csv should be the flat names csv with artist names repeated as many times as images they participate with. sheet rows and images should match, produce multiple flyers for artists that have multiple images)
			</Typography>

			<Typography variant="h5" gutterBottom>
				Production Steps
			</Typography>
			<Typography variant="body1" gutterBottom>
				<ol>
					<li>Receive raw data in 'RAW_Entries' sheet.</li>
					<li>Go to "images folder" and clean up (remove duplicates?, discover missing. This can be avoided during open call, checking daily for incoming entries too)</li>
					<li>
						Create production sheet 'PRODUCTION'. Columns are SUB ID, Last Name, Artist Name, Country, #ofImages, Image1Cap, Image2Cap, Image3Cap, Image4Cap. (purpose = to get only data needed for production)
						<ul>
							<li>Order of appearance is in AZ - defined by Last Name col. Go over Artist name/Last Name and correct Last name where necessary to match order.</li>
							<li>Clean up / format Country (chat)</li>
							<li>Clean up artist links</li>
							<li>Clean up and format image captions. (prompt for captions edit, insert clean captions in columns)</li>
							<li>Create Image*99999*Caption1 column, where in chat, spaces are replaced with *99999* and later in inDesign ith line break</li>
							<li>Create Artist*****Name Col and paste in formatted artist names where ***** will be replaced in indesign with line break</li>
						</ul>
					</li>
					<li>produce QR Codes in Chat. QR code file name should be: LastName_SUBID_ArtistName_QR Code. Download zip and place in images folder. No link? (include in prompt) create blank png to not mess up order during datamerge</li>
					<li>
						Create 'FLAT' sheet with toCOL formula, where if artist appears in rows=to #ofimages and Image1Cap, Image2Cap etc become ImageCap
						<ul>
							<li>Flat Sheet columns: SUB ID, Last Name, Artist Name, Artist****Name, Country, ImageCap, ImageFileName ('@imageArt), ImageQR ('@imageQR), ImageCap, Image*99999*Caption</li>
						</ul>
					</li>
					<li>
						InDesign for production of video slides.
						<ul>
							<li>All artist images, QR codes and datamergecsv are in same folder.</li>
							<li>Data merge map csv to fields, data merge.</li>
							<li>Replace *99999*and ***** with line breaks</li>
							<li>Go over each slide to review and fix</li>
							<li>Add video beginning and ending slides</li>
							<li>Export slides using exporting script, with file <b>name = DD_ProofMySlide_{"{page}"}_{"{name}"}.jpg</b></li>
						</ul>
					</li>
					<li>
						Send slide proofs to artists for review. <b>Old way</b> (upload all to one page on our website.), <b>New way</b> (upload to VD - Proof).
						<ul>
							<li>Upload proof images. no images over 4mbs</li>
							<li>download links csv.</li>
							<li>open csv in sheets. order by artist name copy/paste link column</li>
							<li>go to PRODUCTION sheet, add "prooflink" column, paste links</li>
							<li>go to KIT, click on any sub, inset new field, "shortcode_prooflink"</li>
							<li>upload participants csv to kit to get link</li>
							<li>email artists to requesting they proof</li>
							<li>apply any corrections to PRODUCTION sheet (connect to flat), and inDesign</li>
						</ul>
					</li>
					<li>Create Brochure (manually in indesign)</li>
					<li>Create Certificates</li>
					<li>Create personal flyers</li>
					<li>
						Email artists with all productions including 8,9,10 + link for VIP guest passes.
						<ul>
							<li>Option 1. Upload those in a page on circle (split participants in 2 groups 2 for volume)</li>
							<li>Option 2. Individual links to each (annoying?)</li>
						</ul>
					</li>
					<li>Schedule Invite broadcasts for show</li>
					<li>After show, share documentation photos with artists via dropbox folder. Split in 2 groups (as in step 11)</li>
					<b>Note not to forget:</b> besides columns, two merge sheets, for slides - flat with tocol /// for brochure, etc, each artist 1 line only.
				</ol>
			</Typography>
		</Box>
	);
}

export default DocumentationVideoDisplayPageContent;